function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr && (typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]); if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { useEffect, useState } from 'react';
import { Button, Spinner, CardBody, CardHeader, Card, Form, DropdownToggle, DropdownMenu, DropdownItem, UncontrolledDropdown } from 'reactstrap';
import qs from 'qs';
import { Formik } from 'formik';
import { Select } from "../form";
import SimpleSelect from 'react-select';
import Pagination from "../common/pagination";
import Icon from "../common/icon";
import object from "../../services/utils/object";
import notifications from "../../services/notifications";
import selectHelper from "../form/select/helper";
import getResource from "../../services/resources";
import Context from "../../services/context";
import translator, { t } from "../../services/translator";

var List = /*#__PURE__*/function (_React$Component) {
  _inherits(List, _React$Component);

  var _super = _createSuper(List);

  function List(props) {
    var _this;

    _classCallCheck(this, List);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "state", {
      loading: true,
      collection: [],
      totalItems: 0,
      filters: {},
      navigating: false,
      selected: {}
    });

    if (!props.resource) {
      throw new Error('You must define a resource in ResourceList props');
    }

    var router = _this.props.router; // Parse query to initialize filters values

    _this.state.filters = _objectSpread(_objectSpread({}, _this.initialFiltersValues), qs.parse(router ? router.currentSearch.substring(1) : '')); // Bind function used outside component

    _this.fetch = _this.fetch.bind(_assertThisInitialized(_this));
    _this.orderBy = _this.orderBy.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Initialize component
   */


  _createClass(List, [{
    key: "resource",
    get:
    /**
     * Get resource service class
     *
     * @return {Resource}
     */
    function get() {
      return getResource(this.props.resource);
    }
    /**
     * Initial filters values when filters are empty
     *
     * @type {object}
     */

  }, {
    key: "initialFiltersValues",
    get: function get() {
      return _objectSpread({
        page: 1,
        perPage: 30,
        order: {
          id: 'DESC'
        }
      }, this.props.initialFilters);
    }
    /**
     * Options of input "item per page"
     *
     * @return {array}
     */

  }, {
    key: "perPageOptions",
    get: function get() {
      return this.props.perPageOptions || [30, 60, 120];
    }
    /**
     * Get props to inject in body component
     */

  }, {
    key: "bodyProps",
    get: function get() {
      var _this2 = this;

      return {
        fetch: this.fetch.bind(this),
        resource: this.resource,
        setLoading: function setLoading(loading, callback) {
          return _this2.setState({
            loading: loading
          }, callback);
        },
        collection: this.state.collection || [],
        renderColumn: this.renderColumn.bind(this),
        renderSelect: this.renderSelect.bind(this),
        renderItemActions: this.renderItemActions.bind(this)
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fetch();
      this.body = this.props.body;
      this.actions = this.props.actions;
      this.filters = this.props.filters;
    }
    /**
     * Fetch collection with filters
     *
     * @param {object}  filters
     * @param {boolean} merge
     */

  }, {
    key: "fetch",
    value: function fetch(filters) {
      var _this3 = this;

      var merge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var navigating = filters && filters.page && Number(filters.page) !== Number(this.state.filters.page); // Reset page to 1 on perPage changes

      if (filters && filters.perPage && !filters.page) {
        filters.page = 1;
      } // Merge new filters with new one or reset filters with new value


      filters = merge ? object.merge(this.state.filters, filters) : object.merge(object.clone(this.initialFiltersValues), filters); // Remove all unused properties

      filters = object.unsetProperties(filters, ['', null, undefined]);
      this.setState({
        loading: true,
        filters: filters,
        navigating: navigating,
        selected: {}
      }, function () {
        // Stringify filters in query
        var router = _this3.props.router;

        if (router) {
          router.navigate(router.currentUri + '?' + qs.stringify(filters));
        }

        _this3.resource.list(filters).then(function (data) {
          _this3.setState({
            collection: data['hydra:member'],
            totalItems: data['hydra:totalItems'],
            navigating: false,
            loading: false
          }); // If user navigates between pages we scroll on top of the list


          if (navigating && _this3.listContainer) {
            _this3.listContainer.scrollIntoView();
          }
        }).catch(function () {
          _this3.setState({
            loading: false
          });
        });
      });
    }
    /**
     * Add order by for a field
     * Direction is determinate by current direction value
     *
     * @param {string} field
     */

  }, {
    key: "orderBy",
    value: function orderBy(field) {
      var order = this.state.filters.order; // If order field value is DESC it means that next step is to reset value
      // Scheme is "ASC" first then "DESC" and finally remove it from order by collection

      if (order && order[field] && order[field] === 'DESC') {
        delete order[field];
        var state = {
          filters: _objectSpread(_objectSpread({}, this.state.filters), {
            order: order
          })
        };
        return this.setState(state, this.fetch);
      } // Add order by with 'ASC' then 'DESC'


      this.fetch({
        order: _defineProperty({}, field, !this.getOrderDir(field) ? 'ASC' : 'DESC')
      });
    }
    /**
     * Get current direction order of field
     *
     * @param {string} field
     *
     * @return {?string}
     */

  }, {
    key: "getOrderDir",
    value: function getOrderDir(field) {
      return this.state.filters.order !== undefined && this.state.filters.order[field];
    }
    /**
     * Reset filters value to initial values
     *
     * @param {function} setValues
     */

  }, {
    key: "resetFilters",
    value: function resetFilters(setValues) {
      this.fetch({}, false);
      setValues(this.initialFiltersValues);
    }
    /**
     * Select item id to make massive actions
     *
     * @param {string|number} id - '*' means the whole collection
     */

  }, {
    key: "select",
    value: function select(id) {
      var _this$state = this.state,
          collection = _this$state.collection,
          selected = _this$state.selected;

      if (id === '*') {
        var _selected = {};

        for (var i = 0, len = collection.length; i < len; ++i) {
          _selected[collection[i].id] = true;
        }

        return this.setState({
          selected: _selected
        });
      }

      if (!selected[id]) {
        selected[id] = true;
        this.setState({
          selected: selected
        });
      }
    }
    /**
     * Unselect item id in collection to make massive actions
     *
     * @param {string|number} id - '*' means the whole collection
     */

  }, {
    key: "unselect",
    value: function unselect(id) {
      if (id === '*') {
        return this.setState({
          selected: {}
        });
      }

      var selected = this.state.selected;
      delete selected[id];
      this.setState({
        selected: selected
      });
    }
    /**
     * Toggle selection of an item
     *
     * @param {string|number} id
     */

  }, {
    key: "toggleSelect",
    value: function toggleSelect(id) {
      var _this$state2 = this.state,
          selected = _this$state2.selected,
          collection = _this$state2.collection;
      var method = id === '*' && Object.keys(selected).length === collection.length || selected[id] !== undefined ? 'unselect' : 'select';
      return this[method](id);
    }
    /**
     * Run callback of a multiple action
     *
     * @param {?callback} callback
     */

  }, {
    key: "handleMultipleAction",
    value: function handleMultipleAction(callback) {
      var selected = this.state.selected;
      var ids = Object.keys(selected);

      if (ids.length === 0) {
        return notifications.warning(t('action_ignored'), t('no_item_selected_in_list'));
      }

      typeof callback === 'function' && callback(ids, this.bodyProps);
    }
    /**
     * Run deletion of item(s)
     *
     * @param {string|number[]|string[]|number[]} id
     */

  }, {
    key: "handleDelete",
    value: function handleDelete(id) {
      var _this4 = this;

      var isMultiple = Array.isArray(id);
      this.context.confirm( /*#__PURE__*/React.createElement("div", null, t('confirm_delete'), "`: $", isMultiple ? id.join(', ') : id, "`"), function () {
        _this4.setState({
          loading: true
        }, function () {
          var method = isMultiple ? 'deleteMultiple' : 'delete';

          _this4.resource[method](isMultiple ? {
            id: id
          } : id).then(function () {
            return _this4.fetch();
          });
        });
      });
    }
    /**
     * Build multiple actions options
     *
     * @return {object[]}
     */

  }, {
    key: "buildMultipleActionsOptions",
    value: function buildMultipleActionsOptions() {
      var _this5 = this;

      var multipleActions = _toConsumableArray(this.props.multipleActions || []);

      if (this.props.deleteMultiple && this.resource.canDeleteMultiple()) {
        multipleActions.push({
          label: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Icon, {
            name: "trash-alt",
            className: "mr-2"
          }), " ", t('delete')),
          value: function value() {
            return _this5.handleDelete(Object.keys(_this5.state.selected));
          }
        });
      }

      return multipleActions;
    }
    /**
     * Build column and add orderable event on it
     *
     * @param {string}   field          - Field path
     * @param {?boolean} orderable      - To define only if you want to make column orderable
     * @param {?object}  props          - Props to inject in th tag
     *
     * @return {JSX.Element}
     */

  }, {
    key: "renderColumn",
    value: function renderColumn(field) {
      var _this6 = this;

      var orderable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var props = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var label = typeof field !== 'string' ? field : this.resource.getTranslationKey(field);
      return /*#__PURE__*/React.createElement("th", _extends({
        scope: "col",
        onClick: function onClick() {
          return orderable && _this6.orderBy(field);
        },
        className: field && 'pointer'
      }, props), typeof label === 'string' ? t(label) : label, orderable && /*#__PURE__*/React.createElement(Icon, {
        name: "sort",
        className: "ml-2 ".concat(this.getOrderDir(field) ? 'text-grey' : 'text-light')
      }));
    }
    /**
     * Render item checkbox for multiple selection
     *
     * @param {string|number} itemId
     *
     * @return {JSX.Element}
     */

  }, {
    key: "renderSelect",
    value: function renderSelect(itemId) {
      var _this7 = this;

      var selected = this.state.selected;
      var keys = Object.keys(selected);
      var checked = itemId === '*' ? keys.length > 0 && keys.length === this.state.collection.length : selected[itemId] !== undefined;
      return /*#__PURE__*/React.createElement("div", {
        className: "custom-control custom-checkbox"
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        checked: checked,
        id: 'list-checkbox-' + itemId,
        className: "custom-control-input",
        onChange: function onChange() {
          return _this7.toggleSelect(itemId);
        }
      }), /*#__PURE__*/React.createElement("label", {
        className: "custom-control-label",
        htmlFor: 'list-checkbox-' + itemId
      }));
    }
    /**
     * Render button for navigate to create view
     *
     * @return {JSX.Element|null}
     */

  }, {
    key: "renderCreateButton",
    value: function renderCreateButton(routeNameOrPath) {
      var _this8 = this;

      if (!this.resource.canCreate()) {
        return null;
      }

      var router = this.props.router;

      if (!router) {
        return null;
      }

      var onClick = function onClick() {
        return routeNameOrPath ? router.navigate(routeNameOrPath) : router.navigateToResource(_this8.resource.alias, 'create');
      };

      return /*#__PURE__*/React.createElement(Button, {
        color: "default",
        type: "button",
        className: "mb-3",
        onClick: onClick
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "plus-circle",
        className: "mr-2"
      }), t('create'));
    }
    /**
     * Render ellipsis button with actions for an item
     *
     * @param {object}              item
     * @param {function|JSX.Element }actions
     *
     * @return {JSX.Element}
     */

  }, {
    key: "renderItemActions",
    value: function renderItemActions(item, actions) {
      var _this9 = this;

      return /*#__PURE__*/React.createElement(UncontrolledDropdown, null, /*#__PURE__*/React.createElement(DropdownToggle, {
        color: "",
        className: "btn-icon-only text-light bg-transparent",
        role: "button",
        size: "sm"
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "ellipsis-v"
      })), /*#__PURE__*/React.createElement(DropdownMenu, {
        className: "dropdown-menu-arrow",
        right: true
      }, this.resource.canUpdate() && /*#__PURE__*/React.createElement(DropdownItem, {
        onClick: function onClick() {
          var router = _this9.props.router;
          router.navigateToResource(_this9.resource.alias, 'update', {
            id: item.id
          });
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "pen-alt"
      }), " ", t('edit')), typeof actions === 'function' ? actions(DropdownItem) : actions, this.resource.canDelete() && /*#__PURE__*/React.createElement(DropdownItem, {
        onClick: function onClick() {
          return _this9.handleDelete(item.id);
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "trash-alt"
      }), " ", t('delete'))));
    }
    /**
     * @return {JSX.Element}
     */

  }, {
    key: "render",
    value: function render() {
      var _this10 = this;

      var _this$state3 = this.state,
          loading = _this$state3.loading,
          totalItems = _this$state3.totalItems,
          filters = _this$state3.filters,
          navigating = _this$state3.navigating;
      var Body = this.body,
          Filters = this.filters,
          Actions = this.actions;
      var multipleActions = this.buildMultipleActionsOptions();
      return /*#__PURE__*/React.createElement("div", {
        className: "crud-list"
      }, /*#__PURE__*/React.createElement(Formik, {
        initialValues: filters,
        onSubmit: function onSubmit(v) {
          return _this10.fetch(v, false);
        }
      }, function (formik) {
        var _useState = useState(true),
            _useState2 = _slicedToArray(_useState, 2),
            initContext = _useState2[0],
            setInitContext = _useState2[1];

        useEffect(function () {
          formik.setFormikState(_objectSpread(_objectSpread({}, formik), {}, {
            resource: _this10.resource
          }));
          setInitContext(false);
        }, []); // eslint-disable-line react-hooks/exhaustive-deps

        return !initContext && /*#__PURE__*/React.createElement(React.Fragment, null, _this10.renderCreateButton(), Actions && /*#__PURE__*/React.createElement(Actions, null), Filters && /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardBody, {
          className: "bg-transparent".concat(loading ? ' loading' : '')
        }, /*#__PURE__*/React.createElement(Form, {
          role: "form",
          noValidate: true,
          onSubmit: formik.handleSubmit
        }, /*#__PURE__*/React.createElement("div", {
          className: "list-filters"
        }, /*#__PURE__*/React.createElement(Filters, formik)), /*#__PURE__*/React.createElement("div", {
          className: "text-center pt-3"
        }, /*#__PURE__*/React.createElement(Button, {
          outline: true,
          color: "primary",
          size: "sm",
          type: "submit"
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "filter",
          className: "mr-1"
        }), t('filter')), /*#__PURE__*/React.createElement(Button, {
          outline: true,
          color: "warning",
          size: "sm",
          onClick: function onClick() {
            return _this10.resetFilters(formik.setValues);
          }
        }, /*#__PURE__*/React.createElement(Icon, {
          name: "eraser",
          className: "mr-1"
        }), t('reset')))))), /*#__PURE__*/React.createElement("div", {
          className: "f-height flex align-items-center justify-content-center mb-2 mt-2"
        }, (!loading || navigating) && /*#__PURE__*/React.createElement("span", {
          className: "text-center ".concat(Filters ? 'text-grey' : 'text-white')
        }, /*#__PURE__*/React.createElement("small", {
          className: "font-weight-bold"
        }, t('nb_result', totalItems)))), /*#__PURE__*/React.createElement(Card, {
          className: "shadow",
          id: "list-table-container",
          innerRef: function innerRef(el) {
            return _this10.listContainer = el;
          }
        }, /*#__PURE__*/React.createElement(CardHeader, {
          className: "pt-3 pb-3"
        }, /*#__PURE__*/React.createElement("div", {
          className: "flex align-items-center justify-content-between"
        }, multipleActions === undefined || multipleActions.length === 0 ? /*#__PURE__*/React.createElement("span", null) : /*#__PURE__*/React.createElement("div", {
          style: {
            minWidth: '150px'
          }
        }, /*#__PURE__*/React.createElement(SimpleSelect, {
          placeholder: translator.translate('actions'),
          isSearchable: false,
          isDisabled: loading,
          options: multipleActions,
          noOptionsMessage: function noOptionsMessage() {
            return /*#__PURE__*/React.createElement("small", null, "-");
          },
          value: null,
          onChange: function onChange(_ref) {
            var value = _ref.value;
            return _this10.handleMultipleAction(value);
          },
          styles: selectHelper.buildStyles('sm')
        })), /*#__PURE__*/React.createElement(Select, {
          size: "sm",
          label: false,
          name: "perPage",
          groupTag: "span",
          isDisabled: loading,
          className: "input-per-page",
          options: _this10.perPageOptions.map(function (value) {
            return {
              label: value + ' / ' + translator.translate('page'),
              value: value
            };
          }),
          onSelect: function onSelect(perPage) {
            return _this10.fetch({
              perPage: perPage
            });
          }
        }))), /*#__PURE__*/React.createElement(CardBody, {
          className: "p-0"
        }, loading || !Body ? /*#__PURE__*/React.createElement("div", {
          className: "text-center pt-3 pb-3"
        }, /*#__PURE__*/React.createElement(Spinner, null)) : /*#__PURE__*/React.createElement(Body, _this10.bodyProps))), (!loading || navigating) && Math.ceil(totalItems / filters.perPage) > 1 && /*#__PURE__*/React.createElement("nav", {
          className: "flex justify-content-center mt-3"
        }, /*#__PURE__*/React.createElement(Pagination, {
          perPage: filters.perPage,
          total: totalItems,
          loading: loading,
          active: Number(filters.page),
          onClick: function onClick(page) {
            return _this10.fetch({
              page: page
            });
          },
          disabled: loading
        })));
      }));
    }
  }]);

  return List;
}(React.Component);

_defineProperty(List, "contextType", Context);

export { List as default };